// document.addEventListener("DOMContentLoaded", function () {
//   var apiUrl = 'https://idcp-drumfashion.com:8081/api/crmintegration/member/addMember';
//   var authToken = 'Bearer eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJuYW1laWQiOiIxMDM5IiwidW5pcXVlX25hbWUiOiJDUk0gQVBJIiwiZW1haWwiOiJjcm1hcGlAaWRjcC5teSIsInJvbGUiOiJVc2VyIiwiZGVidWdfbW9kZSI6IkZhbHNlIiwibmJmIjoxNjk1NzkxNzY4LCJleHAiOjE2OTU4NTI5NjgsImlhdCI6MTY5NTc5MTc2OH0.DCpGSepDfIFZEBUy0wU5UGfeVS0udQQkDDzEbjigmjvZaOlYJWX7BZhJPOYZ2kQsdsQ-NADfZylgMEsIqq4_8A';

//   var firstName = document.getElementById("FirstName").value;
//   var email = document.getElementById("Email").value;
//   var phone = document.getElementById("Phone").value;

//   var requestData = {

//   "firstName": "Jass",
//   "lastName": "Preet",
//   "email": "jaspret@email.com",
//   "phone": "012334455767",
//   "birthdate": "1999-01-01T00:00:00.000Z",
//   "gender": "F"
    
//   };

//   var headers = new Headers();
//   headers.append('Content-Type', 'application/json');
//   headers.append('Authorization', authToken);

//   var requestOptions = {
//     method: 'POST',
//     headers: headers,
//     body: JSON.stringify(requestData),
//     mode: 'cors', // You can adjust this as needed
//     cache: 'default', // You can adjust this as needed
//   };

//   fetch(apiUrl, requestOptions)
//   .then(function (response) {
//     return response.json();
//   })
//   .then(function (data) {
//     // Log the API response to the network response tab
//     console.groupCollapsed("API Response");
//     console.log(data);
//     console.groupEnd();

//     // Log the API response to the console
//     console.log("API Response:", data);
//   })
//   .catch(function (error) {
//     console.error("API Error:", error);
//   });
// });
$(document).ready(function(){
  if($('div.customer-profile').hasClass('get_pointss_idcp')){
    let customer_email=$('input#customer-email').val();
    console.log('customer_email',customer_email);
    $.ajax({
    type:"POST",
    url:"https://honesttechguys.com/idcpapi/shopify-app/idcp_getpoints.php",
     data: {
    email: customer_email
     },
    success: function(data) {
    console.log("success$$$$$$$$$$$$$$$$$$$$e",data[0].StatusMessage);
      let responseData= JSON.parse(data);
      console.log('responseData',responseData.StatusMessage);
      if(responseData.StatusMessage==""){
      $(".reward-points span").append(responseData.Data.pointBalance);  
      }
      // else{
      //   $("span.error").append(responseData.StatusMessage); 
      // }
        // $(".reward-points span").append(responseData.Data.pointBalance); 
  },
     error: function (request, status, error) {
       // alert("else3333333",request.responseText);
    }
});
$.ajax({
    type:"POST",
    url:"https://honesttechguys.com/idcpapi/shopify-app/idcp_getpointsinfo.php",
    data: {
    email: customer_email
       //email:'michaellim@email.com'
     },
    success: function(data) {
    console.log("success$$$$$$$$$$$$$$$$$$$$",data);
      let responseData= JSON.parse(data);
      console.log('responseData',responseData);
      if(responseData.StatusCode == 1){
     $(".reward-points span").append(responseData.Data.pointBalance);  
        jQuery(".points-wrap .member-info h4").text('Member Id:'+responseData.Data.memberNum)
        var birth_date = new Date(responseData.Data.birthDate);
        jQuery('.dob_cust').append(birth_date.getDate()+'/'+birth_date.getMonth()+ 1+'/'+birth_date.getFullYear());
          console.log('>>>>>',birth_date.getDate()+'/'+birth_date.getUTCMonth()+ 1+'/'+birth_date.getFullYear());
        if(responseData.Data.pointHistory !== ''){
          // console.log('xxxxxxxx');
        $.each(responseData.Data.pointHistory, function (i,Data) {
    // $.each(Data.pointHistory[i], function (val) {
        console.log('>>>>',Data);
    html='';
    if(Data.pointRedeem==null){
        html+='<div class="price-history-content-wrap"><div class="block_content-inner"> ';
  //  html+='<div class="price-history-content-wrap"><div class="block_content-inner"> ';
    html+=' <span class="history-icons">';
    html+='<img src="https://cdn.shopify.com/s/files/1/0765/7334/4041/t/7/assets/Get_Points.svg?v=1714484116" height="35" alt="custom payments" / >';
    html+='</span>';
    html+='<div class="price-history-inner-text"><h6 class="point-history-title title-colors-green" >Get Points From Purchases</h6>';
    html+='<p class="point-history-subtitle">'+Data.trxType+''+Data.trxDate+'</p>';
    html+='</div></div>';  
        html+='<div class="block-content-price-and-points">';
                   html+='<h6 class="point-history-title title-colors-green">'+Data.pointEarn+'</h6>';
                   html+='<p class="point-history-subtitle">points</p>';
               html+=' </div></div>';
    }else{
        html+='<div class="price-history-content-wrap"><div class="block_content-inner"> ';
  //  html+='<div class="price-history-content-wrap"><div class="block_content-inner"> ';
    html+=' <span class="history-icons">';
    html+='<img src="https://cdn.shopify.com/s/files/1/0765/7334/4041/t/7/assets/Get_Points.svg?v=1714484116" height="35" alt="custom payments" / >';
    html+='</span>';
    html+='<div class="price-history-inner-text"><h6 class="point-history-title  title-colors-yellow" >Get Points From Purchases</h6>';
    html+='<p class="point-history-subtitle">'+Data.trxType+'</p>';
    html+='</div></div>';  
        html+='<div class="block-content-price-and-points">';
                   html+='<h6 class="point-history-title  title-colors-yellow">'+Data.pointEarn+'</h6>';
                   html+='<p class="point-history-subtitle">points</p>';
               html+=' </div></div>';

    }
     
    jQuery('.all-blocks-content').append(html);
          
          
   
         // });
});
        }
      }else{
       $("span.error").append(responseData.message); 
      }
        // $(".reward-points span").append(responseData.Data.pointBalance); 
  },
     error: function (request, status, error) {
       // alert("else3333333",request.responseText);
    }
});

  }
   
})